// extracted by mini-css-extract-plugin
export default {"darkTheme":"ThemeWrapper_darkTheme__BYeuT","lightTheme":"ThemeWrapper_lightTheme__QTQNt"};